<template>
  <transition
    appear
    name="v-img-fade">
    <div
      v-if="!closed"
      class='fullscreen-v-img'
      @click.self="close()">
      <!--
        最外层父容器
        Count of total images in array, current position.
        Hidden if only one image
      -->
      <div class="header-v-img">
        <span
          v-if="images.length > 1"
          class="count-v-img">
          {{ currentImageIndex + 1 }}/{{ images.length }}
        </span>
        <span
          class="close-v-img"
          @click="close">
          &times;
        </span>
      </div>
      <!-- Controls start -->
      <transition
        appear
        name="v-img-fade">
        <!--上一页-->
        <span
          v-if="images.length > 1"
          class="prev-v-img"
          @click="prev">
          <svg
            width="25"
            height="25"
            viewBox="0 0 1792 1915"
            xmlns="http://www.w3.org/2000/svg"><path
              d="M1664 896v128q0 53-32.5 90.5t-84.5 37.5h-704l293 294q38 36 38 90t-38 90l-75 76q-37 37-90 37-52 0-91-37l-651-652q-37-37-37-90 0-52 37-91l651-650q38-38 91-38 52 0 90 38l75 74q38 38 38 91t-38 91l-293 293h704q52 0 84.5 37.5t32.5 90.5z"
              fill="#fff"/></svg>
        </span>
      </transition>
      <transition
        appear
        name="v-img-fade">
        <!--下一页-->
        <span
          v-if="images.length > 1"
          class="next-v-img"
          @click="next(images[currentImageIndex])">
          <svg
            width="25"
            height="25"
            viewBox="0 0 1792 1915"
            xmlns="http://www.w3.org/2000/svg"><path
              d="M1600 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z"
              fill="#fff"/></svg>
        </span>
      </transition>
      <!-- Constols end -->
      <div class="content-v-img">
        <p
          class="down"
          v-if="checkImg(images[currentImageIndex]) === 2">
          <a
            target="_blank"
            :id="endval"
            :boxid="boxid"
            :href="images[currentImageIndex]">请点击下载观看</a>
        </p>
        <div
          class="down1 img-down-pdf"
          style="width: 75%; height: 100%; margin: 6% auto 0"
          v-if="checkImg(images[currentImageIndex]) === 3">
          <template>
            <div style="width: 50%; height: 100%; margin: 0 auto">
              <el-input
                class="jm-input50"
                size="small"
                :disabled="true"
                type="text"
                v-model.number="page"
                style="margin-right: 10px;"/>
              <el-button
                type="info"
                size="small"
                @click="buttonNumber(true)">上一个 （PDF翻页）</el-button>
              <el-button
                type="info"
                size="small"
                @click="buttonNumber(false)">下一个 （PDF翻页）</el-button>
              <pdf
                :src="images[currentImageIndex]"
                :page="page"
                @numPages="numPages = $event"
                style=" width: 80%; height:75%;  margin: 15px auto 0"/>
            </div>
          </template>
        </div>
        <img
          class="endCanvas"
          :id="endval"
          :boxid="boxid"
          :src="images[currentImageIndex]"
          v-if="checkImg(images[currentImageIndex]) === 1"
          @click="next">
      </div>
      <img
        :src="images[currentImageIndex]"
        v-show="false"
        class="delUrl" >
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      images: [],
      visibleUI: true,
      currentImageIndex: 0,
      closed: true,
      uiTimeout: null,
      endval: '',
      boxid: '',
      sImages: [],
      show: false, // pdf
      loadedRatio: 0,
      page: 1,
      numPages: 0,
    };
  },
  props: {
    allDel: {
      type: Boolean,
      default: null
    },
  },
  components: {
    pdf: () => import('@/plugins/pdf/pdf.vue'),
  },
  methods: {
    buttonNumber(isTrue) {
      if (!isTrue) {
        if (this.page > 0 && this.page < this.numPages) {
          this.page++;
        } else {
          this.$message.warning('到尾了');
        }
      } else {
        this.page--;
        if (this.page <= 0) {
          this.page = 1;
          this.$message.warning('到头了');
        }
      }
    },
    close() {
      document.querySelector('body').classList.remove('body-fs-v-img');
      this.images = [];
      this.currentImageIndex = 0;
      this.closed = true;
      document.querySelectorAll('.rotate-area').forEach((item) => {
        item.style.display = 'none';
      });
    },
    next() {
      // if next index not exists in array of images, set index to first element
      if (this.currentImageIndex + 1 < this.images.length) {
        this.currentImageIndex++;
      } else {
        this.currentImageIndex = 0;
      }
      if (this.sImages[this.currentImageIndex].attributes.resultId !== undefined) {
        this.endval = this.sImages[this.currentImageIndex].attributes.resultId.value;
        this.boxid = this.sImages[this.currentImageIndex].attributes.boxsId.value;
      }
      let thisSrc = this.sImages[this.currentImageIndex].src;
      const delLength = document.querySelectorAll('.candelPdf').length;
      if (delLength === 0) {
        this.isShow(thisSrc);
      }
    },
    prev() {
      // if prev index not exists in array of images, set index to last element
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
      } else {
        this.currentImageIndex = this.images.length - 1;
      }
      if (this.sImages[this.currentImageIndex].attributes.resultId !== undefined) {
        this.endval = this.sImages[this.currentImageIndex].attributes.resultId.value;
        this.boxid = this.sImages[this.currentImageIndex].attributes.boxsId.value;
      }
      let thisSrc = this.sImages[this.currentImageIndex].src;
      const delLength = document.querySelectorAll('.candelPdf').length;
      if (delLength === 0) {
        this.isShow(thisSrc);
      }
    },
    rotate(angle) {
      /* eslint-disable */
        let p = this.$el.querySelector('.endCanvas');
        p.angle = angle;
        let rotation = p.angle >= 0 ? (Math.PI * p.angle) / 180 :
          (Math.PI * (360 + p.angle)) / 180;
        let costheta = Math.cos(rotation);
        let sintheta = Math.sin(rotation);
        let canvas = document.createElement('img');
        if (document.all && !window.opera) {
          canvas.src = p.src;
          canvas.height = p.height;
          canvas.width = p.width;
        } else {
          canvas = document.createElement('canvas');
          p.oImage ? canvas.oImage = p.oImage : (canvas.oImage = new Image(),
            canvas.oImage.src = p.src);
          canvas.style.width = canvas.width = Math.abs(costheta *
            canvas.oImage.width) + Math.abs(sintheta * canvas.oImage.height);
          canvas.style.height = canvas.height = Math.abs(costheta *
            canvas.oImage.height) + Math.abs(sintheta * canvas.oImage.width);
          let context = canvas.getContext('2d');
          context.save();
          rotation <= Math.PI / 2 ? context.translate(sintheta * canvas.oImage.height, 0) :
            rotation <= Math.PI ? context.translate(canvas.width,
              -costheta * canvas.oImage.height) : rotation <= 1.5 *
            Math.PI ? context.translate(-costheta * canvas.oImage.width,
              canvas.height) : context.translate(0, -sintheta * canvas.oImage.width);
          context.rotate(rotation);
          context.drawImage(canvas.oImage, 0, 0, canvas.oImage.width, canvas.oImage.height);
          context.restore();
        }
        canvas.id = p.id;
        canvas.className = 'endCanvas';
        canvas.angle = p.angle;
        let trueSrc = canvas.toDataURL('image/jpeg');
        p.src = trueSrc;
      },
      showUI() {
        // UI's hidden, we reveal it for some time only on mouse move and
        // ImageScreen appear
        this.visibleUI = true;
        this.uiTimeout = setTimeout(() => {
          this.visibleUI = false;
        }, 3500);
      },
      isShow(src) {
        if (this.checkImg(src) > 1 ) {
          document.querySelectorAll('.rotate-area').forEach((item) => {
            item.style.display = 'none';
          });
        } else {
          document.querySelectorAll('.rotate-area').forEach((item) => {
            item.style.display = 'block';
          });
        }
      },
      checkImg(url) {
        console.log(url);
        // 验证当前是否为图片
        let isImg = ['bmp', 'jpg', 'jpeg', 'png', 'gif'];
        let isPdf = 'pdf';
        let strTemp = url.split('.');
        // if (url.indexOf('?') > -1) {
        //   strTemp = url.substring(0, url.indexOf('?')).split('.');
        // }
        // let strTemp = url.substring(0, url.indexOf('?')).split('.');
        let strCheck = strTemp[strTemp.length - 1];
        let reg = /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*?)\s*$/i;
        let result = 0;
        if (this.isInArray(isImg, strCheck)) {
          result = 1;
        } else if (isPdf === strCheck) {
          result = 3;
        } else {
          result = 2;
        }
        if (reg.test(strCheck)) {
          result = 1;
        }
        return result;
      },
      isInArray(arr, value) {
        for (let i = 0; i < arr.length; i++) {
          if (value === arr[i]) {
            return true;
          }
        }
        return false;
      }
    },
    created() {
      window.addEventListener('keyup', (e) => {
        // esc key and 'q' for quit
        if (e.keyCode === 27 || e.keyCode === 81) this.close();
        // arrow right and 'l' key (vim-like binding)
        if (e.keyCode === 39 || e.keyCode === 76) this.next();
        // arrow left and 'h' key (vim-like binding)
        if (e.keyCode === 37 || e.keyCode === 72) this.prev();
      });
      window.addEventListener('scroll', () => {
        this.close();
      });
      window.addEventListener('mousemove', () => {
        this.showUI();
      });
    }
  };
</script>

<style>
</style>

<style scoped>

  * {
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
  }

  .fullscreen-v-img {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    overflow: hidden;
    background-color: rgba(0, 0, 0, .7);
    -ms-touch-action: none;
        touch-action: none;
  }
  .content-v-img{
    width: 100%;
    height: 100%;
  }
  .content-v-img img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
  }

  .header-v-img {
    position: absolute;
    width: 100%;
    background-color: rgba(0, 0, 0, .3);
    height: 50px;
    z-index: 1000;
  }

  .count-v-img {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 15px;
    color: white;
    margin-left: 10px;
    line-height: 50px;
  }

  .close-v-img {
    float: right;
    margin-right: 40px;
    margin-top: 15px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    color: #E5E6EB;
    font-size: 50px;
    line-height: 50px;
    cursor: pointer;
    -webkit-transition: color .4s ease-in-out;
    transition: color .4s ease-in-out;
  }

  .close-v-img:hover {
    color: white;
  }

  .prev-v-img svg,
  .next-v-img svg {
    margin: 5px auto;
  }

  .prev-v-img,
  .next-v-img {
    color: white;
    width: 35px;
    height: 35px;
    position: absolute;
    top: 50%;
    margin-top: -12.5px;
    font-size: 15px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    text-align: center;
    background-color: rgba(0, 0, 0, .3);
    z-index: 1000;
    opacity: .3;
    -webkit-transition: opacity .3s ease-in-out;
    transition: opacity .3s ease-in-out;
    cursor: pointer;
  }

  .prev-v-img:hover,
  .next-v-img:hover {
    opacity: 1;
  }

  .prev-v-img {
    left: 10px;
  }

  .next-v-img {
    right: 10px;
  }

  .v-img-fade-enter,
  .v-img-fade-leave-to {
    opacity: 0;
  }

  .v-img-fade-enter-active,
  .v-img-fade-leave-active {
    -webkit-transition: opacity .3s ease-in-out;
    transition: opacity .3s ease-in-out;
  }
  .fullscreen-v-img{
    z-index: 1002;
  }
  .down{
    width: 100%;
    height:100%;
    display: flex;
    justify-content:center;
    align-items: center;
  }
  .down1{
    margin:5% 0;
    display: flex;
    justify-content:center;
    align-items: center;
  }
  .down a{
    font-size: 100px;
    color: #fff;
    background: #3368fa;
    padding: 20px;
    border-radius: 20px;
  }
</style>
